import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { useLoad, Loading, Panel } from "./shared";

const GROUPS = [
  ["Notifications", [["lead_notification_email", "Lead & payment notification email"], ["booking_notification_email", "Booking notification email"], ["playbook_notification_email", "Playbook lead notification email"]]],
  ["Invoicing", [["invoice_company_name", "Invoice company name"], ["invoice_company_email", "Invoice email"], ["invoice_company_address", "Company address"], ["invoice_company_number", "Company number"], ["invoice_payment_terms", "Payment terms"], ["invoice_bank_details", "Bank transfer details (shown on invoices)", true]]],
  ["Agreements", [["agreement_terms", "Standard agreement terms (blank = default Veyronix terms)", true]]],
  ["Website & SEO", [["company_tagline", "Company tagline"], ["default_meta_title", "Default meta title"], ["default_meta_description", "Default meta description", true]]],
];

export const CommerceSettings = ({ call }) => {
  const { data, loading } = useLoad(call, "/settings");
  const crm = useLoad(call, "/crm");
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (data) setForm({ ...data, playbook_enabled: data.playbook_enabled !== false }); }, [data]);
  if (loading) return <Loading />;

  const save = async () => {
    setSaving(true);
    try {
      const { created_at, updated_at, ...body } = form;
      await call("/settings", { method: "PUT", body });
      toast.success("Commerce settings saved");
    } catch { /* toast shown */ } finally { setSaving(false); }
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="commerce-settings">
      <Panel title="Dedicated CRM organisation">
        <div className="p-5 text-sm text-slate-600" data-testid="settings-crm-org">
          <p><b>{crm.data?.organization?.business_name || "—"}</b> · <span className="font-mono text-xs">{crm.data?.organization?.org_id}</span></p>
          <p className="text-xs text-slate-400 mt-1">All Commerce enquiries, bookings and playbook leads are stored only in this organisation. Other customers' CRM data is never read or modified.</p>
        </div>
      </Panel>
      <Panel title="Dropshipping Playbook">
        <div className="p-5 flex items-center justify-between">
          <Label htmlFor="pb-enabled">Accept playbook download requests</Label>
          <Switch id="pb-enabled" checked={!!form.playbook_enabled} onCheckedChange={v => setForm(p => ({ ...p, playbook_enabled: v }))} data-testid="settings-playbook-enabled" />
        </div>
      </Panel>
      {GROUPS.map(([title, fields]) => (
        <Panel key={title} title={title}>
          <div className="p-5 space-y-4">
            {fields.map(([k, label, multi]) => {
              const C = multi ? Textarea : Input;
              return (
                <div key={k} className="space-y-1.5">
                  <Label htmlFor={`s-${k}`}>{label}</Label>
                  <C id={`s-${k}`} value={form[k] || ""} onChange={e => setForm(p => ({ ...p, [k]: e.target.value }))} data-testid={`settings-${k}`} />
                </div>
              );
            })}
          </div>
        </Panel>
      ))}
      <Button onClick={save} disabled={saving} className="bg-indigo-600 hover:bg-indigo-700" data-testid="settings-save-btn">{saving ? "Saving…" : "Save settings"}</Button>
    </div>
  );
};
